export default __webpack_public_path__ + "static/media/game-icon.05d7a7a1.webp";